/* Dansk katalog for locale-supplier-country-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  "purchaseDocs.removeAll": "Fjern alle",
  "purchaseDocs.removeOne": "Fjern {name} fra købet",
  "purchaseDocs.duplicateTitle": "Mulig dobbeltbogføring",
  "purchaseDocs.duplicateHelp": "Kontrollér tidligere køb før bogføring. Du kan stadig bogføre.",
  "purchaseDocs.sameAttachment": "Den samme fil er vedhæftet flere gange.",
  "purchaseDocs.sameFile": "Samme fil er brugt på bilag {number} · {date}.",
  "purchaseDocs.sameDetails": "Bilag {number} · {date} har samme dato og beløb.",
  "purchaseFlow.listTitle": "Købsliste",
  "purchaseFlow.purchaseCount": "Køb",
  "purchaseFlow.netPurchases": "Nettokøb",
  "purchaseFlow.netPurchasesHelp": "Ekskl. moms, efter kreditnotaer",
  "purchaseFlow.includingVat": "Inkl. moms",
  "purchaseFlow.credited": "Krediteret",
  "purchaseFlow.creditable": "Kan stadig krediteres",
  "purchaseFlow.creditAllocationHelp": "Vælg fakturaen før bogføring for automatisk modregning. Beløb over den ubetalte saldo bliver et tilgodehavende hos leverandøren.",
  "err.supplierCredit.invalidAmount": "Kreditbeløbet skal være positivt og må ikke overstige beløbet, der ikke allerede er krediteret. Betalinger reducerer ikke grænsen.",
  "err.purchase.duplicateSupplierDocument": "Dokumentnummeret er allerede registreret for leverandøren. Åbn den eksisterende faktura eller kreditnota.",
  'purchaseFlow.creditNote': 'Kreditnota',
  "purchaseFlow.negativeWarning": "Et negativt fakturabeløb er usædvanligt, medmindre det er en kreditnota.",
  "purchaseFlow.creditOriginal": "Faktura der krediteres (valgfrit)",
  "purchaseFlow.standaloneCredit": "Ingen tilknytning – tilgode hos leverandøren",
  "purchaseFlow.creditLinesRequired": "Brug nye negative linjer og bogfør kreditnotaen direkte. Kladder og redigering understøttes ikke her.",
  "err.supplierCredit.unsupportedLines": "Brug almindelige købslinjer. Lager, aktiver og særlig moms kræver en separat korrektion.",
  'registry.toggleSupplierHelp': 'Foreslår norske virksomheder, mens du skriver leverandørnavn eller organisationsnummer.',
  'sup.foreignToggle': 'Udenlandsk leverandør',
  'sup.foreignToggleHelp': 'Slå til for leverandører, der er registreret i et andet land end din virksomhed.',
  'sup.countryCode': 'Landekode',
  'sup.countryCodePh': 'F.eks. SE eller US',
  'sup.countryRequired': 'Angiv en landekode på to bogstaver for den udenlandske leverandør.',
  'sup.registrationNumber': 'Registreringsnummer',
  'sup.registrationNumberPh': 'Leverandørens udenlandske registreringsnummer',
  'sup.vatNumber': 'VAT-/momsnummer',
  'sup.vatNumberPh': 'F.eks. SE123456789001',
});
